module.exports = __webpack_public_path__ + "img/podium-star.de4b9c05.svg";